import React from 'react';
import { volumes } from '../data/salesCopy';
export function ValueStack() {
  return <section className="w-full border-y border-line bg-night-deep" data-id="element-269" data-mp="247un7mf83gql">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-5 sm:py-16 lg:py-20" data-id="element-270" data-mp="2461c9uxkuacs">
        <div className="text-center" data-id="element-271" data-mp="1q9xookh7l09a">
          <p className="text-[10px] font-semibold uppercase tracking-[0.24em] text-gold sm:text-xs sm:tracking-[0.28em]" data-id="element-272" data-mp="1u9y86jj601n7">
            The complete system
          </p>
          <h2 className="mt-4 font-display text-[1.75rem] uppercase leading-[1] tracking-tight text-cream sm:text-5xl" data-id="element-273" data-mp="2i0apgl0avaqg">
            What’s inside the <span className="text-gold" data-id="element-274" data-mp="297guzgca84s0">six guitar volumes</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-cream-muted sm:text-base" data-id="element-275" data-mp="295e7b2ylqnqg">
            A complete guitar curriculum in order: every page is a print-ready PDF you can teach the
            same day — no prep, no adaptation, no guesswork.
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 sm:gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-276" data-mp="35qy3zp4q0ylz">
          {volumes.map(volume => <article key={volume.number} className="flex h-full flex-col rounded-2xl border border-line bg-panel p-5 transition-colors duration-150 ease-expo hover:border-gold/50 sm:p-6" data-id="element-277" data-mp="1oh1pov995hhn">
              <div className="flex items-baseline justify-between gap-4" data-id="element-278" data-mp="1ycv5cni9pr3n">
                <span className="font-display text-2xl leading-none text-gold" data-id="element-279" data-mp="2c4tbqqklh8w4">
                  {volume.number}
                </span>
                <span className="text-[11px] font-medium uppercase tracking-[0.1em] text-cream-muted" data-id="element-280" data-mp="286c322lizqcl">
                  {volume.pages}
                </span>
              </div>
              <h3 className="mt-3 font-display text-lg uppercase leading-tight tracking-tight text-cream sm:text-xl" data-id="element-281" data-mp="2h5h0f5lcpdn6">
                {volume.title}
              </h3>
              <p className="mt-3 text-[15px] leading-relaxed text-cream-muted" data-id="element-282" data-mp="mrpt4cqhv5uw">{volume.body}</p>
              <ul className="mt-auto flex flex-wrap gap-1.5 pt-5 sm:gap-2" data-id="element-283" data-mp="2mtpfukjrrfbu">
                {volume.tags.map(tag => <li key={tag} className="rounded-full border border-line bg-night px-2.5 py-1 text-[11px] font-medium text-cream-muted sm:px-3 sm:text-xs" data-id="element-284" data-mp="2rt1xmqvs9w7k">
                    {tag}
                  </li>)}
              </ul>
            </article>)}
        </div>
      </div>
    </section>;
}